export const downloadDocument = async (fileName: string) => {
  const file = await import(`../../assets/documents/${fileName}`);
  const a = document.createElement('a');
  a.href = file.default;
  a.download = fileName;
  a.click();
};
